/* FAQ — the category chips scroll the page to their group.

   The chips are plain in-page anchors, so they already work with this file blocked:
   the browser jumps to the group and CSS scroll-margin-top parks it clear of the
   floating header. All this adds is the smooth glide, and it keeps the URL clean —
   writing the hash would make the back button replay the jump. */

(function () {
  'use strict';

  function onClick(event) {
    var link = event.target.closest('.faq__nav a[href^="#"]');
    if (!link) return;

    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;

    event.preventDefault();

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    /* Moving focus is what carries a keyboard or screen reader user along with the
       scroll. The group is not focusable on its own, so it is lent a tabindex for the
       duration and preventScroll stops focus from undoing the smooth scroll. */
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  document.addEventListener('click', onClick);
})();
